export default __webpack_public_path__ + "static/media/logo-ae-dyson.f2c0ce69.svg";